import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import BusinessIcon from '@material-ui/icons/Business';
import PersonIcon from '@material-ui/icons/Person';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import TollIcon from '@material-ui/icons/Toll';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import ReceiptIcon from '@material-ui/icons/Receipt';
import {NavLink, Redirect, Route, Switch} from "react-router-dom";
import {signOut} from "../../store/actions/auth";
import {connect, useSelector} from "react-redux";
import axios from "axios";
import {API_URL} from "../../config";
import Snack from "../Snack/Snack";
import UsersIndex from "../../containers/Users/UsersIndex/UsersIndex";
import UsersCreate from "../../containers/Users/UsersCreate/UsersCreate";
import UsersEdit from "../../containers/Users/UsersEdit/UsersEdit";
import CompaniesIndex from "../../containers/Companies/CompaniesIndex/CompaniesIndex";
import CompaniesCreate from "../../containers/Companies/CompaniesCreate/CompaniesCreate";
import CompaniesEdit from "../../containers/Companies/CompaniesEdit/CompaniesEdit";
import WorkersIndex from "../../containers/Workers/WorkersIndex/WorkersIndex";
import Divider from "@material-ui/core/Divider";
import WorkersCreate from "../../containers/Workers/WorkersCreate/WorkersCreate";
import WorkersEdit from "../../containers/Workers/WorkersEdit/WorkersEdit";
import WorkersView from "../../containers/Workers/WorkersView/WorkersView";
import WorkerMovementsIndex from "../../containers/WorkerMovements/WorkerMovementsIndex/WorkerMovementsIndex";
import WorkerMovementsCreate from "../../containers/WorkerMovements/WorkerMovementsCreate/WorkerMovementsCreate";
import WorkerMovementsEdit from "../../containers/WorkerMovements/WorkerMovementsEdit/WorkerMovementsEdit";
import FeesIndex from "../../containers/Fees/FeesIndex/FeesIndex";
import FeesCreate from "../../containers/Fees/FeesCreate/FeesCreate";
import FeesEdit from "../../containers/Fees/FeesEdit/FeesEdit";
import PaymentsCreate from "../../containers/Payments/PaymentsCreate/PaymentsCreate";
import PaymentsIndex from "../../containers/Payments/PaymentsIndex/PaymentsIndex";
import Test from "../../containers/Test";
import PaymentsSearch from "../../containers/Payments/PaymentsSearch/PaymentsSearch";
import PaymentsMissing from "../../containers/Payments/PaymentsMissing/PaymentsMissing";

const drawerWidth = 300;

const useStyles = makeStyles(theme => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
        textAlign: 'left'
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'stretch'
    },
    container: {
        display: 'flex',
        flex: 1,
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    mainContainer: {
        display: 'flex',
        height: '100vh',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'stretch'
    }
}));

const Dashboard = ({ signOut, readError, authMessage, history }) => {

    const classes = useStyles();

    const authState = useSelector((state) => state.authReducer);

    // State de drawer
    const [open, setOpen] = React.useState(false);

    // State de snackbar
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    // Función que abre el drawer
    const handleDrawerOpen = () => {
        setOpen(true);
    };

    // Función que cierra el drawer
    const handleDrawerClose = () => {
        setOpen(false);
    };

    // Función que cierra la sesión
    const handleLogout = async () => {

        try {

            await axios.post(API_URL + "/logout");
            signOut();

        } catch (error) {
            setSnackbarMessage('Ocurrió un error cerrando la sesión');
            setSnackbarOpen(true);
        }
    };

    return (
        <div style={ { backgroundColor: '#fafafa' } } className={ classes.mainContainer }>
            <AppBar position="sticky">
                <Toolbar className={classes.toolbar}>
                    {
                        authState.roleId === 1 || authState.roleId === 2 || authState.roleId === 3 ?
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="open drawer"
                                onClick={ handleDrawerOpen }
                                className={classes.menuButton}
                            >
                                <MenuIcon />
                            </IconButton>:
                            null
                    }
                    <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                        <NavLink to="/users" style={{ textDecoration: 'none', color: 'white'}} >
                            SJOIIM
                        </NavLink>
                    </Typography>
                    <IconButton color="inherit" onClick={ handleLogout }>
                        <ExitToAppIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            {
                authState.roleId === 1 ?
                    <Drawer
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        onClose={handleDrawerClose}
                        open={open}
                    >
                        <List>
                            <div>
                                <ListItem button component={NavLink} to="/users" activeClassName="Mui-selected">
                                    <ListItemIcon>
                                        <SupervisorAccountIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Usuarios"/>
                                </ListItem>
                                <ListItem button component={NavLink} to="/payments_search" activeClassName="Mui-selected">
                                    <ListItemIcon>
                                        <ReceiptIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Captura de Pagos"/>
                                </ListItem>
                                <Divider />
                                <ListItem button component={NavLink} to="/companies" activeClassName="Mui-selected">
                                    <ListItemIcon>
                                        <BusinessIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Empresas"/>
                                </ListItem>
                                <ListItem button component={NavLink} to="/workers" activeClassName="Mui-selected">
                                    <ListItemIcon>
                                        <PersonIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Trabajadores"/>
                                </ListItem>
                                <ListItem button component={NavLink} to="/worker_movements" activeClassName="Mui-selected">
                                    <ListItemIcon>
                                        <SwapHorizIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Movimientos"/>
                                </ListItem>
                                <ListItem button component={NavLink} to="/fees" activeClassName="Mui-selected">
                                    <ListItemIcon>
                                        <TollIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Conceptos"/>
                                </ListItem>
                                <ListItem button component={NavLink} to="/payments" activeClassName="Mui-selected">
                                    <ListItemIcon>
                                        <ReceiptIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Pagos"/>
                                </ListItem>
                                <ListItem button component={NavLink} to="/payments_missing" activeClassName="Mui-selected">
                                    <ListItemIcon>
                                        <MoneyOffIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Pagos Pendientes"/>
                                </ListItem>
                            </div>
                        </List>
                    </Drawer> :
                    null
            }
            {
                authState.roleId === 2 ?
                    <Drawer
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        onClose={handleDrawerClose}
                        open={open}
                    >
                        <List>
                            <div>
                                <ListItem button component={NavLink} to="/workers" activeClassName="Mui-selected">
                                    <ListItemIcon>
                                        <PersonIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Trabajadores"/>
                                </ListItem>
                                <ListItem button component={NavLink} to="/worker_movements" activeClassName="Mui-selected">
                                    <ListItemIcon>
                                        <SwapHorizIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Movimientos"/>
                                </ListItem>
                            </div>
                        </List>
                    </Drawer> :
                    null
            }
            {
                authState.roleId === 3 ?
                    <Drawer
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        onClose={handleDrawerClose}
                        open={open}
                    >
                        <List>
                            <div>
                                <ListItem button component={NavLink} to="/workers" activeClassName="Mui-selected">
                                    <ListItemIcon>
                                        <PersonIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Trabajadores"/>
                                </ListItem>
                                <ListItem button component={NavLink} to="/worker_movements" activeClassName="Mui-selected">
                                    <ListItemIcon>
                                        <SwapHorizIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Movimientos"/>
                                </ListItem>
                            </div>
                        </List>
                    </Drawer> :
                    null
            }
            <main className={classes.content}>
                    <Switch>
                        { authState.roleId === 1 && <Route path="/users" exact component={UsersIndex}/> }
                        { authState.roleId === 1 && <Route path="/users/create" exact component={UsersCreate}/> }
                        { authState.roleId === 1 && <Route path="/users/:id/edit" exact component={UsersEdit}/> }
                        { authState.roleId === 1 && <Route path="/companies" exact component={CompaniesIndex}/> }
                        { authState.roleId === 1 && <Route path="/companies/create" exact component={CompaniesCreate}/> }
                        { authState.roleId === 1 && <Route path="/companies/:id/edit" exact component={CompaniesEdit}/> }
                        { authState.roleId === 1 && <Route path="/workers" exact component={WorkersIndex}/> }
                        { authState.roleId === 1 && <Route path="/workers/create" exact component={WorkersCreate}/> }
                        { authState.roleId === 1 && <Route path="/workers/:id/edit" exact component={WorkersEdit}/> }
                        { authState.roleId === 1 && <Route path="/workers/:id" exact component={WorkersView}/> }
                        { authState.roleId === 1 && <Route path="/workers/:id/payments/:quarter/create" exact component={PaymentsCreate}/> }
                        { authState.roleId === 1 && <Route path="/worker_movements" exact component={WorkerMovementsIndex}/> }
                        { authState.roleId === 1 && <Route path="/worker_movements/create" exact component={WorkerMovementsCreate}/> }
                        { authState.roleId === 1 && <Route path="/worker_movements/:id/edit" exact component={WorkerMovementsEdit}/> }
                        { authState.roleId === 1 && <Route path="/fees" exact component={FeesIndex}/> }
                        { authState.roleId === 1 && <Route path="/fees/create" exact component={FeesCreate}/> }
                        { authState.roleId === 1 && <Route path="/fees/:id/edit" exact component={FeesEdit}/> }
                        { authState.roleId === 1 && <Route path="/payments" exact component={PaymentsIndex}/> }
                        { authState.roleId === 1 && <Route path="/payments_missing" exact component={PaymentsMissing}/> }
                        { authState.roleId === 1 && <Route path="/payments_search" exact component={PaymentsSearch}/> }
                        { authState.roleId === 1 && <Route path="/test" exact component={Test}/> }
                        { authState.roleId === 1 && <Redirect from="/" to="/workers" /> }
                        { authState.roleId === 2 && <Route path="/workers" exact component={WorkersIndex}/> }
                        { authState.roleId === 2 && <Route path="/workers/create" exact component={WorkersCreate}/> }
                        { authState.roleId === 2 && <Route path="/workers/:id/edit" exact component={WorkersEdit}/> }
                        { authState.roleId === 2 && <Route path="/workers/:id" exact component={WorkersView}/> }
                        { authState.roleId === 2 && <Route path="/worker_movements" exact component={WorkerMovementsIndex}/> }
                        { authState.roleId === 2 && <Route path="/worker_movements/create" exact component={WorkerMovementsCreate}/> }
                        { authState.roleId === 2 && <Route path="/worker_movements/:id/edit" exact component={WorkerMovementsEdit}/> }
                        { authState.roleId === 2 && <Redirect from="/" to="/workers" /> }
                        { authState.roleId === 3 && <Route path="/workers" exact component={WorkersIndex}/> }
                        { authState.roleId === 3 && <Route path="/workers/create" exact component={WorkersCreate}/> }
                        { authState.roleId === 3 && <Route path="/workers/:id/edit" exact component={WorkersEdit}/> }
                        { authState.roleId === 3 && <Route path="/workers/:id" exact component={WorkersView}/> }
                        { authState.roleId === 3 && <Route path="/worker_movements" exact component={WorkerMovementsIndex}/> }
                        { authState.roleId === 3 && <Route path="/worker_movements/create" exact component={WorkerMovementsCreate}/> }
                        { authState.roleId === 3 && <Route path="/worker_movements/:id/edit" exact component={WorkerMovementsEdit}/> }
                        { authState.roleId === 3 && <Redirect from="/" to="/workers" /> }
                        { authState.roleId === 4 && <Route path="/workers" exact component={WorkersIndex}/> }
                        { authState.roleId === 4 && <Route path="/workers/:id" exact component={WorkersView}/> }
                        { authState.roleId === 4 && <Redirect from="/" to="/workers" /> }
                    </Switch>
            </main>
            <Snack message={ snackbarMessage } open={ snackbarOpen } handleClose={ () => setSnackbarOpen(false) } />
        </div>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        signOut: () =>
            dispatch(signOut())
    };
};

export default connect(null, mapDispatchToProps)(Dashboard);
